import {h, Fragment} from "preact"
import {useRef, useEffect} from 'preact/hooks';
import { settings } from "../config"
import ProductCard from './ProductCard'

export default function RecomendationSection() {
    const refSwiper = useRef();
    const swiperVar = useRef();

    const handlePrevButtonClick = () => {
        if (swiperVar.current) {
            swiperVar.current.slidePrev();
        }
    };

    const handleNextButtonClick = () => {
        if (swiperVar.current) {
            swiperVar.current.slideNext();
        }
    };

    useEffect(() => {
        const enableDrag = () => {
            if (swiperVar.current) {
                swiperVar.current.allowTouchMove = true;
            }
        }
    
        const disableDrag = () => {
            if (swiperVar.current) {
                swiperVar.current.allowTouchMove = false;
            }
        }
        try {
            swiperVar.current = new Swiper(refSwiper.current, {
                spaceBetween: 8,
                slidesPerView: 2,
    
                breakpoints: {
                    1024: {
                        slidesPerView: 4
                    }
                }
            });
        } catch(e) {console.error('NoResults -> ', e)}

        const noDragSelectors = refSwiper.current?.querySelectorAll('.swiper-slide .no-swiper-drag');

        noDragSelectors?.forEach(el => {
            el.addEventListener('mouseenter', disableDrag);
            el.addEventListener('mouseleave', enableDrag);
        });

        return () => {
            noDragSelectors.forEach(el => {
                el.removeEventListener('mouseenter', disableDrag);
                el.removeEventListener('mouseleave', enableDrag);
            });
        };
    }, []);

    const products = settings?.may_like_products_list_no_results ?? [];

    return (
        <article class="ss__theme ss__searchspring__recommendations ss__recommendation__profile--no-results">
            <header class="">
                <h3 class="ss__title">You May Like</h3>
                <div class="ss__recs-custom-navigation">
                    <button class="ss__recs-custom-prev" onClick={handlePrevButtonClick}>
                        <svg
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M8.36425 1L15.636 8M15.636 8L8.36425 15M15.636 8L0.364257 8"
                            fill="currentColor"
                            ></path>
                        </svg>
                    </button>
                    <button class="ss__recs-custom-next" onClick={handleNextButtonClick}>
                        <svg
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M8.36425 1L15.636 8M15.636 8L8.36425 15M15.636 8L0.364257 8"
                            fill="currentColor"
                            ></path>
                        </svg>
                    </button>
                </div>
            </header>
            <div class="ss__recommendations-content ss__recs-slider-container ss__results">
                <div class="ss__recommendation">
                    <div class="ss__recommendation-profile-tracker">
                    <div class="ss__carousel ss__recommendation__Carousel">
                        <div class="swiper" ref={refSwiper}>
                        <div class="swiper-wrapper">
                            {products.map(productItem => (
                                <div class="swiper-slide">
                                    <ProductCard product={productItem} />
                                </div>
                            ))}
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </article>
    )
}